import { render, staticRenderFns } from "./ClinicDoctorsIncomeReport.vue?vue&type=template&id=3b85e3d0&scoped=true"
import script from "./ClinicDoctorsIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicDoctorsIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85e3d0",
  null
  
)

export default component.exports